import { ResponsiveValues } from "@faire/web/slate/Theme/ResponsiveValues";

export const MAX_PRIMARY_RESULTS: ResponsiveValues<number> = {
  desktopAndAbove: 15,
  tabletAndAbove: 12,
  mobileAndAbove: 8,
};

export const MAX_PRIMARY_RESULTS_WITH_BANNER: ResponsiveValues<number> = {
  desktopAndAbove: 14,
  tabletAndAbove: 11,
  mobileAndAbove: 7,
};
